/**
 * module - classOfScore
 *
 * This module will calculate the class that belongs to the right
 * score.
 *
 * @param  {Int} score          The score to which the class should be determined
 * @param  {Object} styles      Styles object for webpack style-loader (optional)
 * @param  {string} selector    Selector string to find within styles (optional)
 * @return {string}             String with the right class for score
 */
module.exports = function(score, styles, selector) {

    // Get the score, and make sure it's an integer
    score = parseInt(score);

    // Set the default class to is-score-not-checked
    var scoreClass = 'is-score-not-checked';

    // Check if the score exists and that it isn't -100
    if ((score === 0 || score) && score !== -100) {

        // Create array with possible classes
        var classes = ['is-score-0', 'is-score-50', 'is-score-100'];

        // Check if score is 100
        if (score === 100) {

            // Correct with -1 to 99
            score = 99;
        }

        // Get the class index for this score
        var class_index = Math.floor(score / 100 * classes.length);

        // Set the selected class into the scoreClass variable
        scoreClass = classes[class_index];
    }

    // Check if the styles object is given and the selector is given
    if (styles && selector) {

        // Set the score class to the selector -- scoreclass
        scoreClass = styles[selector + '--' + scoreClass];
    }

    // Expose the scoreClass
    return scoreClass;
};
